import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import { ContentHeader, Loader } from '@components';
import moment from 'moment';
import { toast } from 'react-toastify';
import { getAuditLogById } from '../../services/audit_log';


const ViewAuditLog = () => {
  const [isLoading, setLoading] = useState(false);
  const [logData, setLogData] = useState({
    id: '',
    user_id: '',
    user: '',
    portal_id: '',
    portal_name: '',
    url: '',
    action_name: '',
    request_data: '',
    response: '',
    ip_address: '',
    created_at: ''
  });

  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    if (typeof params.id !== "undefined") {
      getAuditLog(params.id);
    }
  }, [])

  const getAuditLog = (id: any) => {
    setLoading(true);
    getAuditLogById(id).then(function (res: any) {
      const resp = res.data;
      setLoading(false);
      if (res.status === 200 && resp.Acknowledge == 1) {
        let respData = resp.auditLog;
        const obj = JSON.parse(respData.request_data);
        setLogData({
          id: respData.audit_log_id,
          user_id: respData.user_id,
          user: respData.user_name,
          portal_id: respData.portal_id,
          portal_name: respData.portal_name,
          url: respData.url,
          action_name: respData.action_name,
          request_data: JSON.stringify(obj, undefined, 4),
          response: respData.response,
          ip_address: respData.ip_address,
          created_at: respData.created_at ? moment(respData.created_at).format('MM/DD/YYYY HH:mm') : ''
        });
      } else { 
        toast.error(resp.FullMessage ? resp.FullMessage : 'Internal Server Error!');
        navigate("/audit-log");
      }
    }).catch(err => {
      setLoading(false);
      toast.error('Internal Server Error!' + err);
      navigate("/audit-log");
    });
  };

  return (
    <>
      <ContentHeader title='View Log Details' />
      <section className="content">
        <div className="container-fluid">
          <div className="card card_purchase_order">
            <div className="card-body">
              <div className='table-warp-search-pagination'>
                <div className='listing_table_wrap table-responsive'>
                  <h3 className='d-none d-print-block m-2'>View Log</h3>
                  <Link className="btn btn-primary mb-2 back_btn" to={{ pathname: `/audit-log` }}><i className="fas fa-chevron-left"></i> Back</Link>

                  <table className="cell-border table table-bordered table-striped" style={{ width: '100%' }} >
                    <tbody>
                      <tr>
                        <th className='td-left'>Portal</th>
                        <td className='td-left'>{logData.portal_name}</td>
                      </tr>
                      <tr>
                        <th className='td-left'>Title</th>
                        <td className='td-left'>{logData.action_name}</td>
                      </tr>
                      <tr>
                        <th className='td-left'>User</th>
                        <td className='td-left'>{logData.user}</td>
                      </tr>
                      <tr>
                        <th className='td-left'>Method</th>
                        <td className='td-left'>{logData.url}</td>
                      </tr>
                      <tr>
                        <th className='td-left'>Request</th>
                        <td className='td-left' style={{ wordBreak: 'break-all' }}>
                          <pre>{logData.request_data}</pre>
                        </td>
                      </tr>
                      <tr>
                        <th className='td-left'>Ip Address</th>
                        <td className='td-left'>{logData.ip_address}</td>
                      </tr>
                      <tr>
                        <th className='td-left'>Created At</th>
                        <td className='td-left'>{logData.created_at}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <Loader isLoading={isLoading} />
          </div>
        </div >
      </section >
    </>
  )

};

export default ViewAuditLog;